import React, { Fragment, useEffect } from 'react';
import './Sections.scss';
import SectionContent from './SectionContent';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import LogoTooltip from '../LogoTooltip/LogoTooltip';
gsap.registerPlugin(ScrollTrigger);

function Sections({ sectionContents }) {
  useEffect(() => {
    ScrollTrigger.matchMedia({
      '(min-width: 1024px)': function () {
        var action = gsap.to('.logo--sections', {
          opacity: 1,
          y: '20'
        });

        ScrollTrigger.create({
          trigger: '.logo--sections',
          start: 'top top',
          endTrigger: `.section--${sectionContents[sectionContents.length - 1].content}`,
          end: 'bottom 80%',
          pin: true,
          pinSpacing: false,
          animation: action,
          toggleActions: 'play reverse play reverse'
        });
      }
    });
  }, [sectionContents]);

  return (
    <div className="sections">
      <LogoTooltip comp="sections" />
      {sectionContents.map((section, i) => {
        return (
          <Fragment key={section.content}>
            <SectionContent i={i} section={section} />
          </Fragment>
        );
      })}
    </div>
  );
}

export default Sections;
